export const getCurrentRecordingState = (state, patientId, encounterId) => {
  if (!patientId || !encounterId) return { recording: false, paused: false };
  const key = `${patientId}-${encounterId}`;
  return state?.recognizer?.recordingByEncounter?.[key] || { recording: false, paused: false };
}